import { observer } from 'mobx-react-lite';

import { IcCommentsIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.css';

const Comments = ({ message }) => {
  const presenter = usePresenter({ message });
  if (!presenter.canLeaveComment) {
    return null;
  }

  return (
    <IconButton
      className={styles.button}
      Icon={IcCommentsIcon}
      text={presenter.commentsCount || ''}
      onClick={presenter.onClick}
    />
  );
};

export default observer(Comments);
